import { wrapper } from '@/store';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// constants
import { pageTypes } from '@/utils/constants/pageTypes';

// components
import AccordionSection from '@/modules/server-sitemap/accordianSection';

// material
import { Box, Typography } from '@mui/material';

// actions
import { serverSidePropsAction } from '@/utils/page/serverSidePropsAction';

// style
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	pageWrap: {
		padding: theme.spacing(5.5),
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(3, 2, 5.5),
		},
	},
}));

export default function ServerSitemapPage({ data }) {
	const { classes } = useStyles();
	const isMobile = useSelector((state) => state.common.isMobile);

	return (
		<Box className={classes.pageWrap}>
			<Typography
				component="h1"
				variant={isMobile ? 'h4' : 'h3'}
				textAlign="center"
			>
				SITEMAP
			</Typography>
			{data.map((page, index) => (
				<AccordionSection
					key={page.id || index}
					title={page.title}
					items={page.items}
				/>
			))}
		</Box>
	);
}

export const getServerSideProps = wrapper.getServerSideProps(
	(store) => async () => {
		return await serverSidePropsAction(pageTypes.sitemap, '', store);
	}
);

ServerSitemapPage.propTypes = {
	data: PropTypes.array,
};
